export const HEX_RETURN_CAR = '%0A';
export const HEX_SPACE = '%20';
